import { render, staticRenderFns } from "./TheDashboardHeading.vue?vue&type=template&id=3484ee3f&"
import script from "./TheDashboardHeading.vue?vue&type=script&lang=js&"
export * from "./TheDashboardHeading.vue?vue&type=script&lang=js&"
import style0 from "./TheDashboardHeading.vue?vue&type=style&index=0&id=3484ee3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports